@if (stop?.isAnyChanged) {
  <div class="planning-draft-job-stop-change">
    <div class="diff-section-title br-caption-2">
      <span translate>Stop</span>
      @if (stop.stopType) {
        <span>&nbsp;&middot;&nbsp;{{ stop.stopType }}</span>
      }
    </div>

    @if (stop.notBefore) {
      <app-pending-field-row [field]="fields.NOT_BEFORE" [pendingField]="stop.notBefore" [blocked]="isBlocked(fields.NOT_BEFORE)"></app-pending-field-row>
    }
    @if (stop.notAfter) {
      <app-pending-field-row [field]="fields.NOT_AFTER" [pendingField]="stop.notAfter" [blocked]="isBlocked(fields.NOT_AFTER)"></app-pending-field-row>
    }
    @if (stop.detailedServiceTime) {
      <app-pending-field-row [field]="fields.DETAILED_SERVICE_TIME" [pendingField]="stop.detailedServiceTime" [blocked]="isBlocked(fields.DETAILED_SERVICE_TIME)"></app-pending-field-row>
    }
    @if (stop.address) {
      <app-pending-field-row [field]="fields.ADDRESS" [pendingField]="stop.address" [blocked]="isBlocked(fields.ADDRESS)"></app-pending-field-row>
    }
  </div>
}
